
import axios from 'axios'
var hrefData = {}
var configToken = ''
var configSite = {}
var configWS = {}
export default {
	getHrefData() {
		return hrefData
	},
	setHrefData(data) {
		hrefData = data
	},
	setToken(data) {
		configToken = data
	},
	setSite(data) {
		configSite = data
	},
	setWS(data) {

		configWS = data

	},
	getWS() {
		return configWS
	},
	confingWSclose() {

		configWS.close()

	},
	logoutRequest() {

		// 测试默认请求地址
		// let BASE_URL;
		// axios.get('/sever.json').then(response => {
		// 	BASE_URL = response.data.base_url
		// 	console.log("BASE_URL:", BASE_URL);
		// 	const url = BASE_URL + api
		// 	console.log("url:", url);
		// 	console.log("configSite:", configSite);
		// 	console.log(" process.env.NODE_ENV :", process.env);
		// 	// console.log("process.env.VUE_APP_SECRET :", process.env.VUE_APP_SECRET);
		// 	axios.defaults.headers.common['Authorization'] = configToken
		// }).catch(err => {
		// 	console.log("err:", err);
		// })


		// configWS.close()
		let SERVICE_URL = configSite.webUrl
		var api = "/manager/user/quicklogout"
		const url = SERVICE_URL + api

		axios.defaults.headers.common['Authorization'] = configToken

		axios.post(url, {}).then(res => {
			return res
		})
			.catch(err => {
				return err
			})

		// return
		// var api = "/manager/user/logOut";
		// util.postRequest({
		// 	url: api,
		// 	method: "POST",
		// });	
	}
}

// function logoutRequest(){

// }


